import { ReactNode } from "react";

import { Column, MAX_POPOVER_HEIGHT_SM, VerticalScroll } from "@bridgesplit/ui";
import { BsMetaUtil } from "@bridgesplit/abf-react";
import { TokenListMetadata } from "@bridgesplit/abf-sdk";
import { Divider } from "@mui/material";

import { TokenImage } from "../asset";

export const getCheckboxRowProps = (token: TokenListMetadata) => ({
    label: BsMetaUtil.getSymbolUnique(token),
    icon: <TokenImage metadata={token} size="sm" />,
    value: token.mint
});

export function PopoverContentSection({
    children,
    dividerBottom = true,
    dividerTop = false,
    px = 1.5,
    py = 1.5
}: {
    children: ReactNode;
    dividerBottom?: boolean;
    dividerTop?: boolean;
    px?: number;
    py?: number;
}) {
    return (
        <Column>
            {dividerTop && <Divider />}

            <Column sx={{ px, py }}>{children}</Column>
            {dividerBottom && <Divider />}
        </Column>
    );
}

export function PopoverContent({ children, scroll = true }: { children: ReactNode; scroll?: boolean }) {
    return (
        <>
            {scroll ? (
                <PopoverScrollContent>{children}</PopoverScrollContent>
            ) : (
                <PopoverStaticContent>{children}</PopoverStaticContent>
            )}
        </>
    );
}

function PopoverScrollContent({ children }: { children: ReactNode }) {
    return (
        <VerticalScroll spacing={0} maxHeight={MAX_POPOVER_HEIGHT_SM}>
            {children}
        </VerticalScroll>
    );
}

function PopoverStaticContent({ children }: { children: ReactNode }) {
    return <Column>{children}</Column>;
}
